import { Facebook, Instagram, Linkedin } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const WHATSAPP_NUMBER = "14036900222";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Digital Circle! I'd like to talk about a project."
)}`;

export const SOCIALS = [
    { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61593915972805", hover: "hover:border-blue-500 hover:text-blue-400" },
    { icon: Instagram, label: "Instagram", href: "https://instagram.com/digital_circle1", hover: "hover:border-pink-500 hover:text-pink-400" },
    { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/digital-circle-ca/", hover: "hover:border-sky-500 hover:text-sky-400" },
    { icon: WhatsAppIcon, label: "WhatsApp", href: WHATSAPP_URL, hover: "hover:border-emerald-500 hover:text-emerald-400" },
];
